/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Table, TableCell, TableRow, Text } from 'bold-ui'
import { usePecField } from 'components/form/final-form/useField'
import { MetaArray } from 'util/metaPath'

import { AvaliacaoDesenvolvimentoModel } from '../model'
import StatusAvaliacaoTag from './StatusAvaliacaoTag'
import { SwitchButtonField } from './SwitchButtonField'

interface AvaliacaoDesenvolvimentoTableProps {
  name: MetaArray<AvaliacaoDesenvolvimentoModel>
  usePrimaryColors: boolean
}

AvaliacaoDesenvolvimentoTable.defaultProps = {
  usePrimaryColors: false,
}

export default function AvaliacaoDesenvolvimentoTable(props: AvaliacaoDesenvolvimentoTableProps) {
  const { name, usePrimaryColors } = props
  const classes = createStyles()
  const {
    input: { value: rows },
  } = usePecField<AvaliacaoDesenvolvimentoModel>({ name })

  const renderRow = (row: AvaliacaoDesenvolvimentoModel) => {
    if (row.hint)
      return (
        <Text fontWeight='bold'>
          {row.descricao}{' '}
          {row.dataAvaliacao && row.status && (
            <StatusAvaliacaoTag
              status={row.status}
              dataAvaliacao={row.dataAvaliacao}
              usePrimaryColors={usePrimaryColors}
            />
          )}
        </Text>
      )
    return (
      <HFlow hSpacing={0.25} alignItems='center' justifyContent='flex-start'>
        <Text fontWeight='bold'>{row.descricao}</Text>
        {row.dataAvaliacao && row.status && (
          <StatusAvaliacaoTag
            status={row.status}
            dataAvaliacao={row.dataAvaliacao}
            usePrimaryColors={usePrimaryColors}
          />
        )}
      </HFlow>
    )
  }

  return (
    <Table>
      {rows.map((item: AvaliacaoDesenvolvimentoModel, index: number) => (
        <TableRow key={item.id}>
          <TableCell style={classes.row}>{renderRow(item)}</TableCell>
          <TableCell>
            <SwitchButtonField
              name={name.get(index).statusButton}
              usePrimaryColors={usePrimaryColors}
              checkable={!item.dataAvaliacao}
              disable={item.disableButton}
              infoDescription={item.hint}
            />
          </TableCell>
        </TableRow>
      ))}
    </Table>
  )
}

const createStyles = () => ({
  row: css`
    padding: 0.5rem 1rem;
  `,
})
